import React from "react";
import { Dialog } from "@material-ui/core";
import GridOverlayAccordion from "./GridOverlayAccordion";

const GridOverlay = ({ onClose, open, activity }) => {
  const handleClose = () => {
    onClose(open);
  };

  return (
    <Dialog fullWidth maxWidth="md" onClose={handleClose} open={open}>
      <div className="px-4 py-4">
        <div className="grid grid-cols-12 gap-4 mb-4">
          <div className="relative col-span-4">
            <div
              className="pb-44 rounded"
              style={{
                backgroundImage: `url(${activity?.meta?.activity_product_main_image})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
              }}
            ></div>
          </div>
          {activity?.meta?.activity_product_short_description_translated && (
            <div className="relative mb-2 col-span-8 text-lg">
              <h2 className="text-left text-2xl mb-2 leading-none tracking-wide font-bold uppercase">
                {activity?.post_title ? activity.post_title : ""}
              </h2>
              <p>
                {activity.meta.activity_product_short_description_translated}...
              </p>
            </div>
          )}
        </div>
        {activity?.post_content && (
          <GridOverlayAccordion
            title="Beskrivelse"
            content={activity.post_content}
          />
        )}
        {activity?.meta
          ?.activity_product_arrival_day_description_translated && (
          <GridOverlayAccordion
            title="Ankomstdag"
            content={
              activity.meta.activity_product_arrival_day_description_translated
            }
          />
        )}
        {activity?.meta?.activity_product_day_by_day_program_translated && (
          <GridOverlayAccordion
            title="Dagsprogram"
            content={
              activity.meta.activity_product_day_by_day_program_translated
            }
          />
        )}
        {activity?.meta
          ?.activity_product_catering_generic_description_translated && (
          <GridOverlayAccordion
            title="Catering"
            content={
              activity.meta
                .activity_product_catering_generic_description_translated
            }
          />
        )}
        {activity?.meta?.activity_product_direction_instruction_translated && (
          <GridOverlayAccordion
            title="Navigation"
            content={
              activity.meta.activity_product_direction_instruction_translated
            }
          />
        )}
        {activity?.meta?.activity_product_formalities_translated && (
          <GridOverlayAccordion
            title="Formaliteter"
            content={activity.meta.activity_product_formalities_translated}
          />
        )}
        {activity?.meta
          ?.activity_product_included_items_description_translated && (
          <GridOverlayAccordion
            title="Inkluderet"
            content={
              activity.meta
                .activity_product_included_items_description_translated
            }
          />
        )}
        {activity?.meta
          ?.activity_product_personal_equipment_required_translated && (
          <GridOverlayAccordion
            title="Krav til udstyr"
            content={
              activity.meta
                .activity_product_personal_equipment_required_translated
            }
          />
        )}
        {activity?.meta?.activity_product_technical_label_translated && (
          <GridOverlayAccordion
            title="Teknik"
            content={activity.meta.activity_product_technical_label_translated}
          />
        )}
        {activity?.meta
          ?.activity_product_ucpa_specific_equipment_provided_translated && (
          <GridOverlayAccordion
            title="Udstyr inkluderet"
            content={
              activity.meta
                .activity_product_ucpa_specific_equipment_provided_translated
            }
          />
        )}
      </div>
    </Dialog>
  );
};

export default GridOverlay;
/*
activity_product_arrival_day_description_translated;
activity_product_asset;
activity_product_catering_generic_description;
activity_product_day_by_day_program;
activity_product_departure_day_description;
activity_product_direction_instruction;
activity_product_formalities;
activity_product_included_items_description;
activity_product_personal_equipment_required;
activity_product_technical_label;
activity_product_ucpa_specific_equipment_provided;
*/
